import { render, staticRenderFns } from "./bulkndr.vue?vue&type=template&id=542dce7c"
import script from "./bulkndr.vue?vue&type=script&lang=js"
export * from "./bulkndr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports